import Script from "next/script";
import { existsGaId, GA_ID } from "@/components/utils/gtag";

const GoogleAnalytics = () => (
  <>
    {existsGaId && (
      <>
        <Script
          defer
          src={`https://www.googletagmanager.com/gtag/js?id=${GA_ID}`}
          strategy="afterInteractive"
        />
        <Script id="ga" defer strategy="afterInteractive">
          {`
              window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments);}
              gtag('js', new Date());
              gtag('config', '${GA_ID}');
              gtag('config', 'AW-18145522848');
          `}
        </Script>
      </>
    )}
  </>
);

export default GoogleAnalytics;
